import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Directive, HostListener, PLATFORM_ID, inject, input } from '@angular/core';
import { environment } from '../../../environments/environment';

@Directive({
  selector: '[appConversion]',
})
export class ConversionClickDirective {
  readonly appConversion = input('vitrine');
  private readonly document = inject(DOCUMENT);
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  @HostListener('click')
  record(): void {
    if (!this.isBrowser) return;

    const payload = JSON.stringify({
      source: this.appConversion(),
      locale: this.document.documentElement.lang || 'und',
    });

    // Best-effort aggregate telemetry. No cookie, visitor ID or IP is sent in
    // the payload, and keepalive lets navigation continue without blocking.
    void fetch(`${environment.apiUrl}/conversion/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true,
      credentials: 'omit',
      referrerPolicy: 'strict-origin',
    }).catch(() => undefined);
  }
}
